import React from "react";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Chip from '@material-ui/core/Chip';
import Container from "@material-ui/core/Container";
import BackButton from "../Buttons/BackButton"
import PhoneButton from "../Buttons/PhoneButton";
import TimeTable from "./TimeTable";
import WhatsappButton from "../Buttons/WhatsappButton";
import UserAvatar from "../UserAvatar";
import Rating from "./Rating";
import Toolbar from "../Menu/Toolbar";
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";

const style = {
    "fontFamily":"Open Sans Hebrew", 
    textAlign: "right",
    alignSelf: "stretch",
    lineHeight: 0.2
}

const top_elements_style = {
    width: "100%"
}

const publish_style = {
    fontFamily:"Open Sans Hebrew", 
    fontSize: "15px",
    color: "#c4c4c4",
    "margin-top": "11px",
    float: "left"
};

const back_button_style = {
    color: "#c4c4c4",
    float: "right"
};

const header_text_style = {
    lineHeight: 1.3
};

const buttons_style = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};
const sticky = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    background: 'rgb(255, 255, 255) transparent',
    position: '-webkit-sticky',
    position: 'sticky',
    top: 5,
    bottom: 5, 
};

const chips_style = {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 1.7
}

const rating_style = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

const paper_style = {
    display: "flex",
    padding: 20,
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
}; 

const bottom_text_style = {
    fontFamily:"Open Sans Hebrew", 
    fontSize: "14px",
    color: "#c4c4c4",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1.3
};

class StudentInfo extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            allData: {},
            menuOpen: false,
        };
    }
    
    menuClickHandler = () => {
        this.setState((prevState) => {
        return { menuOpen: !prevState.menuOpen };
        });
    };

    backDropClickHandler = () => {
        this.setState({ menuOpen: false });
    };

    getGender() {
        if (this.props.location.state.details["stud_gender"] == "female") {
            return "נקבה";
        } 
        return "זכר";
    }

    getCurrentStatus = () => {
        switch(this.props.location.state.details["current_occupation"]) {
          case "student":
            return "סטודנט/ית";
          case "service_duty":
            return "בן/בת שירות";
          case "assistance":
            return "סייע/ת";
          case "care_staff_member":
            return "איש/אשת צוות טיפולי";
          case "teacher":
            return "איש/אשת חינוך מיוחד";
          default:
            return "אחר";
        }
      }

      getPreferences() {
        var details = [];
        if (this.props.location.state.details["is_autistic_spectrum"] == true) {
            details.push("מאובחנים על הספקטרום האוטיסטי");
        }
        if (this.props.location.state.details["is_intellectual_limitation"] == true) {
            details.push("מאובחנים עם מוגבלות שכלית");
        }
        if (this.props.location.state.details["is_delayed_developed"] == true) {
            details.push("מאובחנים עם עיכוב התפתחותי");
        }
        if (this.props.location.state.details["is_physical_limitation"] == true) {
            details.push("מאובחנים עם מוגבלות פיזית");
        }
        if (this.props.location.state.details["is_behavioral_difficulty"] == true) {
            details.push("מתמודדים עם קשיים התנהגותיים");
        }
        if (this.props.location.state.details["is_nursing_assistance"] == true) {
            details.push("צריכים סיוע סיעודי");
        }
        if (this.props.location.state.details["is_medical_assistance"] == true) {
            details.push("צריכים סיוע רפואי");
        }
        return details;    
    }

      getRelevantAges() {
        var ages = [];
        if (this.props.location.state.details["relevant_ages"]["zero_to_one"] == true) {
            ages.push("0-1");
        }
        if (this.props.location.state.details["relevant_ages"]["one_to_two"] == true) {
            ages.push("1-2");
        }
        if (this.props.location.state.details["relevant_ages"]["two_to_five"] == true) {
            ages.push("2-5");
        }
        if (this.props.location.state.details["relevant_ages"]["five_to_twelve"] == true) {
            ages.push("5-12");
        }
        if (this.props.location.state.details["relevant_ages"]["twelve_to_twenty_five"] == true) {
            ages.push("12-25");
        }
        if (this.props.location.state.details["relevant_ages"]["twenty_five_plus"] == true) {
            ages.push("12-25");
        }
        // show in ascending order.
        ages.reverse();
        return ages;
    }

    getExperience() {
        // enter logic later.
        return "0";
    }

    getRegion() {
        let region = '';
        switch(this.props.location.state.details["region"]) {
            case "north":
              return "צפון";
            case "tel-aviv":
              return "תל אביב";
            case "haifa":
              return "חיפה";
            case "south":
              return "דרום";
            case "jerusalem":
              return "ירושלים";
            case "center":
                return "מרכז";
            default:
              return "אחר";
          }
          return region;
    }

    getCities() {
        if (this.props.location.state.details["cities"] == undefined) {
            return "לא צוין";
        }
        let cities = [];
        var i;
        for (i = 0; i < this.props.location.state.details["cities"].length; i++) {
            cities.push(this.props.location.state.details["cities"][i]["name"]);
        }
        var cities_display = [];
        function addChip(item) {
            cities_display.push(<Chip size="small" label={item}/>);
            cities_display.push(<a>&nbsp;</a>);
        }
        cities.forEach(addChip);
        cities_display = <div style={chips_style}>{cities_display}</div>;
        return cities_display;
    }

    getPublishDate = () => {
        if (this.props.location.state.details["registration_date"] == undefined) {
            return "1.1.2020";
        }
        return this.props.location.state.details["registration_date"];
    }

    render() {
        // if the page was refreshed, redirect to home.
        if (this.props.location.state == undefined) {
            window.location.assign('/');
        }
        // menu related.
        let sideDrawer;
        let backDrop;
        if (this.state.menuOpen) {
            sideDrawer = <SideDrawer userData={this.props.location.state.details} closeMenu={this.backDropClickHandler} />;
            backDrop = <BackDrop click={this.backDropClickHandler} />;
        }
        // create a chip array to display relevant ages.
        var ages = this.getRelevantAges();
        let ages_display = [];
        // if there are no prefered ages, display "no preference".
        if (ages.length == 0) {
            ages_display = <p><font size="2" style={{fontFamily:"Open Sans Hebrew"}}> ללא העדפה </font></p>;
        // if there are prefered ages, put them in chips.
        } else {
            function addChip(item) {
                ages_display.push(<Chip size="small" label={item}/>);
                ages_display.push(<a>&nbsp;</a>);
            }
            ages.forEach(addChip);
            ages_display = <div style={chips_style}>{ages_display}</div>;
        }
        // create a chip array to display preferences about disabillity.
        var preferences = this.getPreferences();
        let preferences_display = [];
        // if there are no additional preferences, display "other".
        if (preferences.length == 0) {
            preferences_display = <p><font size="2" style={{fontFamily:"Open Sans Hebrew"}}> אחר </font></p>;
        // if there are preferences, put them in chips.
        } else {
            function addChip(item) {
                preferences_display.push(<Chip size="small" fontFamily="Open Sans Hebrew" label={item}/>);
                preferences_display.push(<a>&nbsp;</a>);
            }
            preferences.forEach(addChip);
            preferences_display = <div style={chips_style}>{preferences_display}</div>;
        }      
        return (
            <Container component="main" maxWidth="xs">
                <Toolbar drawerClickHandler={this.menuClickHandler} textPage={this.props.location.state.details["full_name"]}/>
                {sideDrawer}
                {backDrop}
                <Box m={5}/>
                <Paper style = {paper_style}>
                    <div style = {style}>
                        <div style = {top_elements_style}>
                            <div style={back_button_style}>
                                <BackButton></BackButton>
                            </div>
                            <div style={publish_style}>
                                <text> פורסם: {this.getPublishDate()}</text>
                            </div>
                        </div>
                        <Box m={5}/>
                        <div>
                            <div style={{display: "inline-block"}}>
                                <UserAvatar attributes={this.props.location.state.details}/>
                            </div>
                            <div style={{display: "inline-block", lineHeight: "0.2"}}>
                                <p><b><font size="4"> &nbsp; {this.props.location.state.details["full_name"]} ,{this.props.location.state.details["age"]}&nbsp; </font></b></p>
                                <p><font size="4"> &nbsp; {this.getCurrentStatus()} </font></p>
                            </div>
                        </div>
                        <Box m={3}/>
                        <div>
                            <p><b><font size="3"> מגדר </font></b></p>
                            <p><font size="3"> {this.getGender()} </font></p>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> טלפון </font></b></p>
                            <p><font size="3"> {this.props.location.state.details["phone_number"]} </font></p>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> מייל </font></b></p>
                            <p><font size="3"> {this.props.location.state.details["email"]} </font></p>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> אזור פעילות </font></b></p>
                            <p><font size="3"> {this.getRegion()} </font></p>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> ערים מועדפות </font></b></p>
                            <p><font size="3"> {this.getCities()} </font></p>
                        </div>
                        {/* <Box m={5}/>
                        <div>
                            <p><b><font size="3"> תקופת ניסיון עם ילדים עם צרכים מיוחדים </font></b></p>
                            <p><font size="3"> {this.getExperience()} שנים </font></p>
                        </div> */}
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3" style={header_text_style}> אני מעדיפ/ה לעשות בייביסיטר לילדים בגילאים </font></b></p>
                            <div> {ages_display} </div>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3" style={header_text_style}> אני מעוניין לעבוד עם ילדים ש... </font></b></p>
                            <div> {preferences_display} </div>
                        </div>
                        <Box m={5}/>
                        <p><b><font size="3"> אני פנוי/ה לבייביסיטר בזמנים </font></b></p>
                        <TimeTable attributes={this.props.location.state.details} />
                        <Box m={5}/>
                        <text color="#808080" style={bottom_text_style}>להמשך בירור פרטים יש ליצור קשר עם נותן השירות. </text>
                        <Box m={2}/>
                        <div style={sticky} >
                            <WhatsappButton attributes = {this.props.location.state.details["phone_number"]} city={this.props.location.state.details["city"]} />
                            <Box m={1}/>
                            <PhoneButton attributes = {this.props.location.state.details["phone_number"]} />
                        </div>
                        <Box m={3}/>
                        <text color="#808080" style={bottom_text_style}>נעזרת בשירות של {this.props.location.state.details["full_name"]}? כיצד היית מדרג את השירות שקיבלת? </text>
                        <Box m={2}/>
                        <div style={rating_style} >
                            <Rating babysitter={this.props.location.state.details}></Rating>
                        </div>
                    </div> 
                </Paper>
            </Container>  
        );
    }
}

export default StudentInfo;